<section
  class="rs-content-wrapper rs-header-has-level2"
  id="tvLevelTwo"
  *ngIf="!hasError || selectedProduct || isPending"
>
  <mprd-skeleton-tv-level-two *ngIf="!selectedProduct"></mprd-skeleton-tv-level-two>
  <main *ngIf="selectedProduct" id="maincontent" role="main">
    <section class="rs-pos-rel rs-mh-s25 rs-mh-m35">
      <mprd-back-link></mprd-back-link>
      <div class="rs-bg-black rs-bgtl-7 rs-pos-tl rs-maxw rs-mh-s25 rs-mh-m35"></div>
      <div>
        <div class="row">
          <div class="columns small-12">
            <div class="rs-pos-rel">
              <div class="rs-fe3"></div>
              <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit" data-cy="tvTitle">
                {{ 'tv.title' | translate }}
              </h1>
              <p class="rs-txt-s5 rs-txt-c2" x-ms-format-detection="none">
                <mprd-access-number-formatter
                  [accessNumber]="selectedProduct?.accessNumber"
                  [plc]="selectedProduct?.plc"
                ></mprd-access-number-formatter>
              </p>
              <div class="panel rs-panel-big clearfix">
                <mprd-usage-header
                  [product]="selectedProduct"
                  [remainingDaysLabel]="remainingDaysLabel"
                  *ngIf="remainingDaysLabel"
                ></mprd-usage-header>
                <div class="row" data-masonry-container="">
                  <div class="columns small-12 medium-6" data-masonry-item-sizer=""></div>
                  <div class="columns small-12 medium-6" data-masonry-item="">
                    <px-usage-level-2-container
                      [product]="usageProduct"
                      (usageRemainingDays)="usageInitializedWith($event)"
                    >
                    </px-usage-level-2-container>
                  </div>

                  <div class="columns small-12 medium-6" data-masonry-item="">
                    <div class="panel rs-bg-grey1" *ngIf="selectedProduct.tvApp">
                      <h3 class="rs-tit6 rs-txt-c1 small-only-text-center">
                        {{ 'tv.relatedApp.title' | translate }}
                      </h3>
                      <div class="rs-flex-row rs-justify-center">
                        <div class="rs-flex-columns">
                          <a
                            href="{{ 'tv.relatedApp.link' | translate }}"
                            class="rs-block text-center rs-link-no-decoration rs-txt-c1 rs-txt-hover rs-txt-s3"
                            data-cy="tvRelatedApp"
                          >
                            <img
                              alt=""
                              class="rs-radius2 rs-h-s8 rs-margin-left2 rs-margin-right2 rs-margin-bottom1"
                              [src]="'tv.relatedApp.image.url' | translate"
                            /><br />
                            {{ selectedProduct.tvApp?.productDescription }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="columns small-12 medium-6" data-masonry-item="">
                    <px-bipt
                      *ngIf="selectedProduct && isRes"
                      [plc]="selectedProduct.plc"
                      [serviceId]="selectedProduct.accessNumber"
                      [analyticsLocation]="'tv options'"
                    ></px-bipt>
                  </div>
                </div>

                <div class="rs-me"></div>

                <h2 class="rs-tit3">{{ 'common.options' | translate }}</h2>

                <ng-container *ngIf="showAllAvailableOptions">
                  <div class="rs-flex-row" data-cy="tvOptionBox">
                    <div *ngIf="tvBonusEligible" class="rs-flex-columns small-12 medium-6">
                      <mprd-tv-bonus [product]="selectedProduct"></mprd-tv-bonus>
                    </div>
                    <div class="rs-flex-columns small-12 medium-6">
                      <mprd-netflix-banner [product]="selectedProduct" [isUnmigratedTvCustomer]="isUnmigratedCustomer"></mprd-netflix-banner>
                    </div>
                  </div>

                  <div class="rs-me"></div>
                </ng-container>

                <mprd-tv-available-options-container *ngIf="showAllAvailableOptions; else tplPersonalizedSubscriptions" [isUnmigratedTvCustomer]="isUnmigratedCustomer"></mprd-tv-available-options-container>
              </div>

              <div class="rs-mh-s2 rs-mh-m6"></div>

              <div class="rs-le2"></div>
            </div>
          </div>
          <!-- START - FAQ -->
          <div [innerHtml]="faqHtml"></div>
          <!-- END - FAQ -->
        </div>
      </div>
    </section>
  </main>
</section>

<ng-template #tplPersonalizedSubscriptions>
  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6" (click)="onClickPersonalizedOptionsCtaBanner()" (keydown.enter)="onClickPersonalizedOptionsCtaBanner()" [innerHTML]="'eshare.tv.optionCtaBanner' | translate"></div>
  </div>
</ng-template>
